import { useAppContext } from "../../context";
import { playClick } from "../../utils";
import { Button } from "../Button";
import { CandidatesList } from "./desktop/List";

interface IButtons {
    disabled: boolean;
    onButton: (isAccepted: boolean) => void;
    onResultButton: () => void;
    isResult: boolean;
    stage: number;
}

export const InterButtons = ({ disabled, onButton, onResultButton, isResult, stage }: IButtons) => {

    const { gameStarted, gameResult, musicPlay, isMobile } = useAppContext();

    const handleSingleButton = () => {
        playClick(musicPlay);
        onResultButton();
    }

    const handleDirectionButton = (val: boolean) => {
        playClick(musicPlay)
        onButton(val);
    }

    const buttons = () => {
        if (isResult) {
            return (
                <Button
                    onClick={handleSingleButton}
                    disabled={disabled}
                    type="grey"
                    text="Далее"
                    className="w-full mt-4 short:mt-8"
                />
            );
        }

        return (
            <div className="w-full flex justify-between items-center gap-4 mt-4 short:mt-8 z-10">
                <Button
                    onClick={() => handleDirectionButton(true)}
                    disabled={disabled}
                    type="green"
                    text="На полку"
                    className="w-[50%]"
                />
                <Button
                    onClick={() => handleDirectionButton(false)}
                    disabled={disabled}
                    type="red"
                    text="На выход"
                    className="w-[50%]"
                />
            </div>
        );
    }
    if (!gameStarted || gameResult) return;

    return isMobile ? (
        <div className={`absolute inset-x-0 bottom-0 h-[160px] short:h-[125px] items-center bg-[url('/images/interview/note.webp')] bg-cover bg-top z-10 flex justify-center align-center px-4`} >
            {buttons()}
        </div>
    ) : (
        <div className={`absolute px-10 pt-[75px] flex-col bottom-8 right-8 h-full max-h-[320px] w-[448px] items-center bg-[url('/images/interview/desktop/note.webp')] bg-cover bg-top z-20 flex justify-end align-center`} >
            <div className="flex justify-between w-full text-cgrey">
                <p className="font-bold text-[20px]/[20px]">Кандидаты</p>
                <p><span className="font-bold text-[18px]/[18px]">{stage}</span> из 5</p>
            </div>

            <CandidatesList stage={stage} isResult={isResult} />

            <div className="w-full flex justify-end gap-4 mt-auto mb-[72px] short:mt-8 z-10">
                {!isResult ? <>
                    <Button
                        onClick={() => handleDirectionButton(true)}
                        disabled={disabled}
                        type="green"
                        text="На полку"
                        className="w-[50%]"
                    />
                    <Button
                        onClick={() => handleDirectionButton(false)}
                        disabled={disabled}
                        type="red"
                        text="На выход"
                        className="w-[50%]"
                    />
                </> : <Button
                    onClick={handleSingleButton}
                    disabled={disabled}
                    type="grey"
                    text="Далее"
                    className="w-full"
                />}
            </div>
        </div>
    )
};